document.addEventListener("turbo:load", function () {
  // Create and append the script
  const script = document.createElement("script");
  script.id = "google-translate-script";
  script.src = "https://translate.google.com/translate_a/element.js?cb=window.googleTranslate.googleTranslateElementInit";
  script.dataset.turbo_track = 'reload';
  script.async = true;
  document.head.appendChild(script);

  // Ensure dropdown button and menu are initialized
  const dropdownBtn = document.getElementById("google-translate-btn");
  const dropdownMenu = document.getElementById("google-translate-dropdown");

  if (dropdownBtn && dropdownMenu) {
    dropdownBtn.removeEventListener("click", googleTranslate.toggleDropdown);
    dropdownBtn.addEventListener("click", googleTranslate.toggleDropdown);
  }
});

class GoogleTranslateController {
  toggleDropdown() {
    document.getElementById("google-translate-dropdown").classList.toggle("hidden");
  }

  changeLanguage(lang, flag) {
    if (lang === 'ro') {
      this.resetTranslation();
    } else {
      const select = document.querySelector('select.goog-te-combo');
      if (select) {
        select.value = lang;
        select.dispatchEvent(new Event('change'));
      }

      const flagImgs = document.querySelectorAll("#current-flag");
      flagImgs.forEach(flagImg => {
        flagImg.src = `https://flagcdn.com/${flag}.svg`;
      });
    }
  }

  resetTranslation() {
    // Restore original page language
    if (window.googleTranslator) {
      let restored = false;
      Object.keys(window.googleTranslator).forEach((key) => {
        if (restored) return;
        const translator = window.googleTranslator[key];
        if (typeof translator?.restore === 'function') {
          translator.restore();
          restored = true;
        }
      });
    }

    // Remove translation cookie to ensure changes persist
    document.cookie = `googtrans=; expires=${new Date(0).toUTCString()}; path=/; domain=${window.location.hostname}`;

    // Ensure flag is set to Romanian
    const flagImgs = document.querySelectorAll("#current-flag");
    flagImgs.forEach(flagImg => {
      flagImg.src = "https://flagcdn.com/ro.svg";
    });

    // Hide the Google Translate top bar using CSS
    googleTranslate.hideTranslateBar();
  }

  googleTranslateElementInit() {
    window.googleTranslator = new google.translate.TranslateElement({
      pageLanguage: 'ro', // Default page language
      includedLanguages: 'ro,en,fr,de,es,it,hu', // Include Romanian as well
      layout: google.translate.TranslateElement.InlineLayout.HORIZONTAL,
    }, 'google_translate_element');
  }

  hideTranslateBar() {
    const style = document.createElement('style');
    style.innerHTML = `
      .goog-te-banner-frame.skiptranslate {
        display: none !important;
      }
      iframe.skiptranslate {
        visibility: hidden !important;
      }
      body {
        top: 0px !important;
      }
    `;
    document.head.appendChild(style);
  }
}

window.googleTranslate = new GoogleTranslateController();
